import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';


// Tabs
import TrainingsEditTab from './Elements/TrainingsEditTab';
import TrainingCertificationsTab from './Elements/TrainingCertificationsTab';
import TrainingLogbooksTab from './Elements/TrainingLogbooksTab';
import TrainingStaffsTab from './Elements/TrainingStaffsTab';
import TrainingResultsTab from './Elements/TrainingResultsTab';
import TrainingCertificationStaffPaymentsTab from './Elements/TrainingCertificationStaffPaymentsTab';
import TrainingConfirmationsTab from './Elements/TrainingConfirmationsTab';
import TrainingAlertsTab from './Elements/TrainingAlertsTab';
import TrainingRevisionsTab from './Elements/TrainingRevisionsTab';
import getLocale from '../../i18n/getLocale';

const PropTypes = require('prop-types');

class TrainingsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      file: {
        class: '',
        status_str: '',
        status_alt_str: '',
        id: '',
      },
      redirect_url: false,
      loaded: 0,
      actual_id: this.props.match.params.id,
      key: 1,
      training_data: {},
      certifications: {},
      staff_list: null,
      staff_available_list: null,
      training_certifications: {},
      training_certifications_select: null,
      training_certification_staffs: null,
      training_certification_instructors: null,
      training_certification_staff_payments: null,
      training_revisions_data: null,
      iframe: 'iframe-hidden',
      url_export: null,
      confirmations: null,
      updated: 0,
      alert_files: 0,
      alert_files_str: '',
      archive: '',
      modal: false,
      modal_available: false,
      modal_change_status: false,
      modal_email: false,
      staffs_available: {},
      alerts: {},
      alerts_log: {},
      files: {},
      emails: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.confirmChangeStatus = this.confirmChangeStatus.bind(this);
    this.preddictionChangeStatus = this.preddictionChangeStatus.bind(this);
    this.changeStatusAlertFiles = this.changeStatusAlertFiles.bind(this);
    this.generatePayment = this.generatePayment.bind(this);
    this.openAlertModal = this.openAlertModal.bind(this);
    this.openAvailableModal = this.openAvailableModal.bind(this);
    this.openChangeStatusModal = this.openChangeStatusModal.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.closeAlertModalAvailable = this.closeAlertModalAvailable.bind(this);
    this.closeChangeStatusModal = this.closeChangeStatusModal.bind(this);
    this.openEmailModal = this.openEmailModal.bind(this);
    this.closeEmailModal = this.closeEmailModal.bind(this);
    this.changePresence = this.changePresence.bind(this);
    this.export = this.export.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.addStaff = this.addStaff.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChangeEmails(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if((this.state.loaded === 1 && prevState.loaded === 0)) {
      this.setState({actual_id: this.props.match.params.id});
      this.setState({loaded: 2}, this.loadData());
    }
    if((this.props.match.params.id !== this.state.actual_id)) {
      this.handleAlert('', '', 'open');
      this.setState({actual_id: this.props.match.params.id});
      var responseJson = {data: '', status: '', message: ''};
      this.updateData(responseJson);
    }
  }

  updateData (responseJson) {
    this.setState({updated: 1}, this.loadData(responseJson));
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/treinamentos');
        if (responseJson.status === 'success') {
          self.setState({training_data: responseJson.data});
          self.setState({alert_files: responseJson.data.alert_files});
          self.setState({alert_files_str: responseJson.data.alert_files_str});
        }
      }).then(() => {
      var url = config.get('api') + '/tripulantes/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/disponiveis/select/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certifications_select: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/logbooks/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_logbooks: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/disponiveis/lista/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certifications: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/alunos/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_staffs: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/instrutores/examinadores/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_instructors: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/tripulantes/disponiveis/lista/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_available_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificados/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certifications: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/' + self.props.match.params.id + '/diarias/alunos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_staff_payments: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/' + self.props.match.params.id + '/alunos/presenca';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({confirmations: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/' + self.props.match.params.id + '/alertas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({alerts_log: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/verificar/presencas/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({verify_confirmations: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/verificar/finalizados/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({verify_finalized: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/revisoes/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_revisions_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/verificar/revisao/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({verify_revision_opened: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (self.state.updated == 1) {
          self.handleAlert(event.message, event.status, 'open');
          self.setState({updated: 0});
        } else {
          self.handleMessage();
        }
      }); /* Overlay */ }); /* verificação de revisão */ }); /* Revisões do treinamento */}); /* Presenças */ }); /* Alertas do treinamento */ }); /* Verificacao de confirmaçao de presenças */ }); /* Verificacao de finalizaçao de certificados aprovados */ }); /* Diáris do treinamento */ }); /* Certificados do treinamento */ }); /* Listagem tripulantes disponiveis */ }); /* Certificados e examinadores/instrutores do treinamento */}); /* Certificados e tripulantes do treinamento */ }); /* Listagem certificados */ }); /* Listagem tripulantes ativos */}); /* Listagem tripulantes ativos */}); /* Listagem tripulantes ativos */
    });
  }

  confirmChangeStatus(event) {
    this.handleAlert('', '', 'open');
    var url = event.currentTarget.value;
    var confirm = this.locale.Treinamentos.EditarTreinamento.trocarStatus;
    if(url === '/treinamento/' + this.state.training_data.id + '/trocar/status/0') {
      confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.trocarStatusParaCancelado);
    } else if (url === '/treinamento/' + this.state.training_data.id + '/trocar/status/2') {
      confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.trocarStatusParaDivulgado);
    }
    if (confirm) {
      this.setState({
        modal_change_status: false,
        iframe: 'iframe-hidden',
      });
      var datasave = {};
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  changeStatus(url) {
    var confirm = this.locale.Treinamentos.EditarTreinamento.trocarStatus;
    if(url === '/treinamento/' + this.state.training_data.id + '/trocar/status/0') {
      confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.trocarStatusParaCancelado);
    } else if (url === '/treinamento/' + this.state.training_data.id + '/trocar/status/2') {
      confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.trocarStatusParaDivulgado);
    } else if (url === '/treinamento/' + this.state.training_data.id + '/trocar/status/4') {
      confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.trocarStatusParaFinalizado);
    }
    if (confirm) {
      var datasave = {};
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  preddictionChangeStatus(event) {
    var self = this;
    var url = event.currentTarget.value;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
            iframe: 'iframe',
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }
      });
    });
  }

  changeStatusAlertFiles(url) {
    if(this.state.alert_files == 1) {
      this.setState({alert_files: 0});
      this.setState({alert_files_str: this.locale.Treinamentos.EditarTreinamento.ignorarFichas});
    } else {
      this.setState({alert_files: 1});
      this.setState({alert_files_str: this.locale.Treinamentos.EditarTreinamento.fichasNecessarias});
    }
    this.handleAlert('', '', 'open');
    var datasave = {};
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  generatePayment() {
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.gerarOsPagamentosDosAlunosDePresencaConfirmada);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {};
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/gerar/pagamento/' + self.props.match.params.id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  openEmailModal() {
    this.setState({
      modal_email: true,
    });
  }

  closeEmailModal() {
    this.setState({
      modal_email: false,
    });
  }

  sendEmail(event) {
    event.preventDefault();
    var data = new FormData();
    var imagedata = document.querySelector(".input-archive").files[0];
    var json_arr = JSON.stringify(this.state.exp_type);
    data.append("emails", this.state.emails);
    data.append("exp_type", json_arr);
    data.append("imagem", imagedata);
    data.append("training_id", this.props.match.params.id);
    var header = this.refs.request_api.header();
    var self = this;
    if(typeof this.state.exp_type === null){
      self.handleAlert(this.locale.Treinamentos.EditarTreinamento.selecioneUmTipoDeExportacao, 'error', 'open');
    } else {
      if(typeof imagedata !== 'undefined'){
        var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.desejaEnviarEmail);
      } else {
        var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.naoHaNenhumArquivoAnexado);
      }
      if (confirm) {
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/treinamento/enviar/email', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  }

  openAvailableModal() {
    this.handleAlert('', '', 'open');
    var datasave = {};
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/tripulantes/elegeiveis/' + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          modal_available: true,
          staffs_available: responseJson.data,
        });
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openAlertModal() {
    this.handleAlert('', '', 'open');
    var datasave = {};
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/alertas/' + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({
          modal: true,
          alerts: responseJson.data,
        });
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  openChangeStatusModal() {
    this.setState({
      modal_change_status: true,
    });
  }

  closeChangeStatusModal() {
    this.setState({
      modal_change_status: false,
      iframe: 'iframe-hidden',
    });
  }
  closeAlertModal() {
    this.setState({
      modal: false,
      alerts: {},
    });
  }

  closeAlertModalAvailable() {
    this.setState({
      modal_available: false,
      staffs_available: {},
    });
  }

  changePresence() {
    this.setState({
      attendence: true,
    });
  }



  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }


  // Fetch salvando a edição
  addStaff(staff_id) {
    this.handleAlert('', '', 'open');
    var datasave = {
      staff_id: staff_id,
      training_id: this.state.training_data.id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificados/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.updateData(responseJson);
        self.closeAlertModalAvailable();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Treinamentos.EditarTreinamento.titulo}</h3>

      {/* Botão de fichas */}
      <div className="grid-buttons pull-right">
        <button  className="btn btn-primary" onClick={self.openAvailableModal}><i className="fa fa-user"></i> {this.locale.Treinamentos.EditarTreinamento.botaoTripulantesElegiveis}</button>
        {(this.state.training_data.status === 2 || this.state.training_data.status === 4) ?
          <button className="btn btn-success" onClick={this.generatePayment}><i className="fa fa-dollar"></i> {this.locale.Treinamentos.EditarTreinamento.botaoConfirmarPagamentos}</button>
          :
          ''
        }
        {(this.state.training_data.status === 2 || this.state.training_data.status === 4) ?
          <Dropdown id="export-data">
            <Dropdown.Toggle bsStyle={'primary'}>
              <i className="fa fa-fw fa-file-pdf-o"></i> {this.locale.Treinamentos.EditarTreinamento.botaoExportar.Exportar}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/solo/'}>{this.locale.Treinamentos.EditarTreinamento.botaoExportar.Solo}</MenuItem>
              <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/solo-tic/'}>{this.locale.Treinamentos.EditarTreinamento.botaoExportar.SoloTIC}</MenuItem>
              <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/simulador/'}>{this.locale.Treinamentos.EditarTreinamento.botaoExportar.Simulador}</MenuItem>
              <MenuItem onSelect={this.export} eventKey={'/exportar/comunicado/treinamento/ead/'}>{this.locale.Treinamentos.EditarTreinamento.botaoExportar.EAD}</MenuItem>
            </Dropdown.Menu>
          </Dropdown>
          :
          ''
        }
        <Dropdown id="change-file">
          <Dropdown.Toggle bsStyle={(this.state.alert_files === 1) ? "danger" : "success" }>
            {this.state.alert_files_str}
          </Dropdown.Toggle>
          {(this.state.alert_files === 1) ?
            <Dropdown.Menu className="super-colors">
              <MenuItem onSelect={this.changeStatusAlertFiles} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/ficha/0'}>{this.locale.Treinamentos.EditarTreinamento.botaoFichas.TrocarParaIgnorarFichas}</MenuItem>
            </Dropdown.Menu>
          :
            <Dropdown.Menu className="super-colors">
              <MenuItem onSelect={this.changeStatusAlertFiles} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/ficha/1'}>{this.locale.Treinamentos.EditarTreinamento.botaoFichas.TrocarParaFichasNecessarias}</MenuItem>
            </Dropdown.Menu>
          }
        </Dropdown>
        <button  className="btn btn-warning" onClick={self.openAlertModal}><i className="fa fa-warning"></i> {this.locale.Treinamentos.EditarTreinamento.botaoAlertas}</button>
        <Dropdown id="revisions">
          <Dropdown.Toggle bsStyle={'danger'}>
            <i className="fa fa-fw fa-certificate"></i> {this.state.training_data.status_str}
          </Dropdown.Toggle>
            {(this.state.training_data.status === 1 || this.state.training_data.status === 3) ?
              <Dropdown.Menu className="super-colors">
                <MenuItem onSelect={this.openChangeStatusModal} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/2'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.TrocarParaDivulgado}</MenuItem>
                <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.TrocarParaCancelado}</MenuItem>
              </Dropdown.Menu>
            :
              (this.state.training_data.status === 2) ?
                <Dropdown.Menu className="super-colors">
                  <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/4'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.TrocarParaFinalizado}</MenuItem>
                  <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.TrocarParaCancelado}</MenuItem>
                </Dropdown.Menu>
              :
                (this.state.training_data.status === 3) ?
                  <Dropdown.Menu className="super-colors">
                    <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.Cancelado}</MenuItem>
                  </Dropdown.Menu>
                :
                  <Dropdown.Menu className="super-colors">
                    <MenuItem onSelect={this.changeStatus} eventKey={'/treinamento/' + this.state.training_data.id + '/trocar/status/0'}>{this.locale.Treinamentos.EditarTreinamento.botaoStatus.Cancelado}</MenuItem>
                  </Dropdown.Menu>
            }
        </Dropdown>
        <button  className="btn btn-info" onClick={self.openEmailModal}><i className="fa fa-envelope"></i> {this.locale.Treinamentos.EditarTreinamento.botaoEmail}</button>
        <Link to="/treinamentos" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>


      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.tituloTab}>
          <TrainingsEditTab updateData={this.updateData} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} />
        </Tab>
        <Tab eventKey={2} title={this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloTab}>
          <TrainingCertificationsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} certifications={this.state.certifications} training_certifications={this.state.training_certifications} staff_list={this.state.staff_list} />
        </Tab>
        <Tab eventKey={3} title={this.locale.Treinamentos.EditarTreinamento.tabAlunos.tituloTab}>
          <TrainingStaffsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certification_staffs={this.state.training_certification_staffs} staff_available_list={this.state.staff_available_list} />
        </Tab>
        <Tab eventKey={4} title={this.locale.Treinamentos.EditarTreinamento.tabDiarias.tituloTab}>
          <TrainingCertificationStaffPaymentsTab status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_certification_staff_payments={this.state.training_certification_staff_payments} />
        </Tab>
        {(this.state.training_data.status !== 1 && this.state.training_data.status !== 3) ?
        <Tab eventKey={5} title={this.locale.Treinamentos.EditarTreinamento.tabPresenca.tituloTab}>
          <TrainingConfirmationsTab status={this.state.training_data.status} updated={this.state.updated} updateData={this.updateData} handleAlert={this.handleAlert} training_id={this.props.match.params.id} confirmations={this.state.confirmations} verify_confirmations={this.state.verify_confirmations} />
        </Tab>
        :
          ''
        }
        {(this.state.training_data.status === 2) ?
        <Tab eventKey={6} title={this.locale.Treinamentos.EditarTreinamento.tabAlertas.tituloTab}>
          <TrainingAlertsTab status={this.state.training_data.status} updated={this.state.updated} updateData={this.updateData} handleAlert={this.handleAlert} training_id={this.props.match.params.id} alerts={this.state.alerts_log} />
        </Tab>
        :
          ''
        }
        {(this.state.training_data.status === 4) ?
        <Tab eventKey={7} title={this.locale.Treinamentos.EditarTreinamento.tabResultados.tituloTab}>

          <TrainingResultsTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certification_staffs={this.state.training_certification_staffs} training_certification_instructors={this.state.training_certification_instructors} staff_available_list={this.state.staff_available_list} verify_finalized={this.state.verify_finalized} />

        </Tab>
        :
          ''
        }
        {(this.state.training_data.status !== 1 && this.state.training_data.status !== 3) ?
        <Tab eventKey={8} title={this.locale.Treinamentos.EditarTreinamento.tabLogbook.tituloTab}>

          <TrainingLogbooksTab updateData={this.updateData} status={this.state.training_data.status} updated={this.state.updated} handleAlert={this.handleAlert} training_id={this.props.match.params.id} training_data={this.state.training_data} training_certifications_select={this.state.training_certifications_select} staff_list={this.state.staff_list} training_certification_logbooks={this.state.training_certification_logbooks} />

        </Tab>
        :
          ''
        }
        {(this.state.training_data.status !== 1 && this.state.training_data.status !== 3) ?
        <Tab eventKey={9} title={this.locale.Treinamentos.EditarTreinamento.tabRevisao.tituloTab}>
          <TrainingRevisionsTab handleAlert={this.handleAlert} status={this.state.training_data.status} training_id={this.props.match.params.id} training_revisions_data={this.state.training_revisions_data} verify_revision_opened={this.state.verify_revision_opened} training_status={this.state.training_data.status} />
        </Tab>
        :
          ''
        }
      </Tabs>
    </div>
  </div>
  <Modal show={this.state.modal_change_status} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4><strong>{this.locale.Treinamentos.EditarTreinamento.tituloSelecioneOTipoDePDF}</strong></h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeChangeStatusModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
        <div>
          <div className="row">
            <div className="col-md-3">
              <button className="btn btn-success btn-block btn-lg" onClick={this.preddictionChangeStatus} value={'/exportar/comunicado/treinamento/solo/'}><i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.botaoSolo}</button>
            </div>
            <div className="col-md-3">
              <button className="btn btn-success btn-block btn-lg" onClick={this.preddictionChangeStatus} value={'/exportar/comunicado/treinamento/solo-tic/'}><i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.botaoSoloTIC}</button>
            </div>
            <div className="col-md-3">
              <button className="btn btn-success btn-block btn-lg" onClick={this.preddictionChangeStatus} value={'/exportar/comunicado/treinamento/simulador/'}><i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.botaoSimulador}</button>
            </div>
            <div className="col-md-3">
              <button className="btn btn-success btn-block btn-lg" onClick={this.preddictionChangeStatus} value={'/exportar/comunicado/treinamento/ead/'}><i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.botaoEAD}</button>
            </div>
          </div>
        </div>
        <div>
          <hr/>
          <iframe className={this.state.iframe} height="600px" width="100%" src={this.state.url_export} name="iframe_a"></iframe>
        </div>
        <div>
          <button className="btn btn-success btn-block btn-lg" onClick={this.confirmChangeStatus} value={'/treinamento/' + this.state.training_data.id + '/trocar/status/2'}><i className="fa fa-fw fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.botaoConfirmarTrocaDeStatus}</button>
          <button className="btn btn-danger btn-block btn-lg" onClick={this.closeChangeStatusModal}>
          <i className="fa fa-fw fa-close"></i>{this.locale.Treinamentos.EditarTreinamento.botaoCancelar}</button>
        </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeChangeStatusModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tituloInformativoDeAlertas}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {Object.keys(self.state.alerts).map(function(name) {
        var tcs = self.state.alerts[name];
        return (
          <div>
            <h4 className='crew-background-style'><strong>{name}</strong></h4>
            {Object.keys(tcs).map(function(certification) {
              var alerts = tcs[certification];
              return (
                <div>
                  <h5><strong>{certification}</strong></h5>
                  {Object.keys(alerts).map(function(k) {
                    return (
                      <div dangerouslySetInnerHTML={{__html: alerts[k].message}}></div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_available} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tituloTripulantesElegiveis}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModalAvailable}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>{this.locale.Treinamentos.EditarTreinamento.tabelaTripulantesElegiveis.Tripulante}</th>
            <th>{this.locale.Treinamentos.EditarTreinamento.tabelaTripulantesElegiveis.Certificado}</th>
            <th>{this.locale.Treinamentos.EditarTreinamento.tabelaTripulantesElegiveis.DataDeExpiracao}</th>
            <th>{this.locale.Treinamentos.EditarTreinamento.tabelaTripulantesElegiveis.Prazo}</th>
            <th className="col-md-2">{this.locale.Treinamentos.EditarTreinamento.tabelaTripulantesElegiveis.Acoes}</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(self.state.staffs_available).map(function(k) {
            return (
              <tr>
                <td>{self.state.staffs_available[k].staff.name}</td>
                <td>{self.state.staffs_available[k].certification.name}</td>
                <td>{self.state.staffs_available[k].expire_str}</td>
                <td>{self.state.staffs_available[k].deadline}</td>
                <td>
                  {(self.state.training_data.status === 1 || self.state.training_data.status === 3) ?
                    <button className="btn btn-success btn-block" onClick={() => (self.addStaff(self.state.staffs_available[k].staff_id))}><i className="fa fa-plus"></i> {self.locale.general.adicionar}</button>
                    :
                    ''
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeAlertModalAvailable}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_email} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.Treinamentos.EditarTreinamento.tituloEnvioDeEmail}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeEmailModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <h4>{this.locale.Treinamentos.EditarTreinamento.tituloUploadDeArquivos}</h4>
    <form onSubmit={this.sendEmail}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.Arquivo}:</label>
            <input type="file" name="archive" className="form-control input-archive" placeholder={this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.SelecionarExportacaoDoTreinamento}:</label>
            <Select
              className="form-field-name"
              name="exp_type"
              value={self.state.exp_type}
              searchable={true}
              multi={true}
              placeholder={this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.placeholder.SelecionarTipo}
              onChange={self.handleSelectChangeEmails.bind(self, 'exp_type')}
              options={[
                {value: "SOLO", label: this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.opcoesTipo.Solo},
                {value: "SOLO-TIC", label: this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.opcoesTipo.SoloTIC},
                {value: "SIMULADOR", label: this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.opcoesTipo.Simulador},
                {value: "EAD", label: this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.opcoesTipo.EAD},
              ]}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.SelecionarDestinatariosExtras}:</label>
            <input type="email" name="emails" className="form-control input-emails" placeholder={this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.placeholder.SeparePorVirgula} value={this.state.emails} multiple onChange={this.handleChange.bind(this, 'emails')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> {this.locale.Treinamentos.EditarTreinamento.formularioUploadDeArquivos.botaoEnviarEmail}</button>
          </div>
        </div>
      </div>
    </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeEmailModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

TrainingsEdit.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default TrainingsEdit;



// WEBPACK FOOTER //
// ./src/Components/Trainings/TrainingsEdit.js